var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateConfidential(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3 23.5217V20.2311C66.3 20.1092 66.1781 19.9873 66.0562 19.9873H18.8906C18.7687 19.9873 18.6469 20.1092 18.6469 20.2311V23.5217",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8343 58.0125H66.0562C66.1781 58.0125 66.3 57.8906 66.3 57.7688V27.0563C66.3 26.9344 66.1781 26.8125 66.0562 26.8125H18.8906C18.7687 26.8125 18.6469 26.9344 18.6469 27.0563V31.2",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6938 50.9438H55.6969",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2593 50.9438H48.2625",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.703 50.9438H42.5343",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6031 41.6813V35.5875C49.6031 35.4656 49.725 35.3438 49.8469 35.3438H59.3531C59.475 35.3438 59.5969 35.4656 59.5969 35.5875V41.6813C59.5969 41.8031 59.475 41.925 59.3531 41.925H49.8469C49.6032 41.925 49.6031 41.8031 49.6031 41.6813Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8906 43.1437L21.9375 46.1905L27.6656 40.4624",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4687 53.5027L23.8875 58.0121H23.7656L17.1843 53.5027C13.7718 51.1871 11.7 47.2871 11.7 43.1434V33.6371C11.7 33.3934 11.8218 33.2715 12.0656 33.2715H35.5875C35.8312 33.2715 35.9531 33.3934 35.9531 33.6371V43.1434C35.9531 47.2871 33.8812 51.1871 30.4687 53.5027Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7656 50.9436C27.9388 50.9436 31.3219 47.5605 31.3219 43.3873C31.3219 39.2141 27.9388 35.8311 23.7656 35.8311C19.5924 35.8311 16.2094 39.2141 16.2094 43.3873C16.2094 47.5605 19.5924 50.9436 23.7656 50.9436Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateConfidential);
export default __webpack_public_path__ + "static/media/private-confidential.bf49029697fec8df9fc6f6ffaba7c9fb.svg";
export { ForwardRef as ReactComponent };